export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Sneakers, boots, sandals, and all footwear styles",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    description: "Cozy hoodies, sweatshirts, and knit sweaters",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    description: "Graphic tees, plain shirts, and casual tops",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    description: "Outerwear, bomber jackets, and winter coats",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    description: "Jeans, cargo pants, joggers, and shorts",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    description: "Caps, beanies, bucket hats, and accessories",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    description: "Matching tracksuits and coordinated outfit sets",
  },
  {
    name: "underwear/underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    description: "Underwear, boxers, and intimate apparel",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    description: "Sports jerseys, team shirts, and athletic wear",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    description: "Watches, jewelry, glasses, and small accessories",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    description: "Backpacks, handbags, crossbody bags, and luggage",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/category-922-Belts.html",
    description: "Fashion belts, leather straps, and waist accessories",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/category-923-Perfumes.html",
    description: "Fragrances, colognes, and scent collections",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/category-924-Other+Stuff.html",
    description: "Miscellaneous items and unique finds",
  },
];

export const heroImages = [
  "https://readdy.ai/api/search-image?query=Premium%20fashion%20flatlay%20on%20marble%20surface%20with%20luxury%20sneakers%20designer%20handbag%20sunglasses%20and%20gold%20jewelry%20warm%20natural%20lighting%20editorial%20product%20photography%20soft%20shadows%20minimal%20aesthetic&width=1600&height=900&seq=hero-1&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Collection%20of%20premium%20sneakers%20arranged%20on%20clean%20white%20background%20warm%20studio%20lighting%20product%20photography%20minimal%20aesthetic%20high-end%20fashion&width=800&height=600&seq=cat-shoes&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Folded%20luxury%20hoodies%20and%20sweaters%20stacked%20on%20wooden%20surface%20warm%20natural%20lighting%20fashion%20product%20photography%20cozy%20minimal%20aesthetic&width=800&height=600&seq=cat-hoodies&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Designer%20jackets%20and%20outerwear%20hanging%20on%20minimal%20rack%20warm%20ambient%20lighting%20fashion%20editorial%20photography%20clean%20background&width=800&height=600&seq=cat-jackets&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Luxury%20handbags%20and%20backpacks%20arranged%20on%20neutral%20surface%20warm%20studio%20lighting%20product%20photography%20minimal%20elegant%20composition&width=800&height=600&seq=cat-bags&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Premium%20fashion%20accessories%20collection%20watches%20sunglasses%20jewelry%20on%20clean%20surface%20warm%20natural%20lighting%20editorial%20style&width=800&height=600&seq=cat-accessories&orientation=landscape",
];

export const articleList = [
  {
    slug: "allchinabuy-spreadsheet-complete-guide",
    title: "AllChinaBuy Spreadsheet Complete Guide",
    excerpt: "A comprehensive guide to understanding and using the AllChinaBuy spreadsheet for smarter product discovery and buying decisions.",
    date: "2026-08-25",
    readTime: "8 min read",
    category: "Guide",
  },
  {
    slug: "allchinabuy-review-2026",
    title: "AllChinaBuy Review 2026",
    excerpt: "An independent review of AllChinaBuy platform, covering shipping costs, QC processes, warehouse features, and user experience.",
    date: "2026-08-20",
    readTime: "6 min read",
    category: "Review",
  },
  {
    slug: "allchinabuy-shipping-cost-guide",
    title: "AllChinaBuy Shipping Cost Guide",
    excerpt: "Everything you need to know about AllChinaBuy shipping methods, costs, and delivery times for different regions.",
    date: "2026-08-15",
    readTime: "5 min read",
    category: "Shipping",
  },
  {
    slug: "allchinabuy-safety-tips",
    title: "AllChinaBuy Safety Tips for Buyers",
    excerpt: "Essential safety guidelines to protect yourself when using AllChinaBuy, including QC verification and payment security.",
    date: "2026-08-10",
    readTime: "7 min read",
    category: "Safety",
  },
];